import * as types from '../mutation-types';
import { Message } from 'element-gui';
import { getDigitalEnvelope } from '@/api/openDecrypt';
const state = {
  bidderDecryptMsg: [],
};

const getters = {
  getBidderDecrypt: (state) => state.bidderDecryptMsg,
};

const actions = {
  async setBidderDecrypt({ commit }, obj) {
    await getDigitalEnvelope({
      domainId: obj.obj.domainId,
      bidderName: obj.row.bidderName,
      bidderId: obj.row.bidderId,
      openBidId: obj.openBidId,
      stage: obj.stage,
      role: obj.role,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_BIDDERDECRYPT_STATUS, res.data.list);
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
};

const mutations = {
  [types.GET_BIDDERDECRYPT_STATUS](state, obj) {
    state.bidderDecryptMsg = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
